export function controllerIdentifierForPath(path) {
    return path
        .replace(/^\.\.\//, '')
        .replace(/\/controller\.js$/, '')
        .replaceAll('_', '-')
        .replaceAll('/', '--')
}
